module.exports = __webpack_public_path__ + "img/Gideons_Mobile.jpg";